import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { reportUser } from "../../../actions/report";

const ReportUser = ({
  setReportUserOpen,
  profile: { user, channelid, avatar, firstname, lastname, jobtitle, location },
  reportUser,
}) => {
  const [formData, setFormData] = useState({
    text: "",
  });
  const [isCurrent, setCurrent] = useState({
    racism: false,
    inappropriate: false,
    spam: false,
    impersonation: false,
    threat: false,
    other: false,
  });

  const { text } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <Fragment>
      <div className="report-overlay">
        <div className="report-container">
          <i
            className="fas fa-times fa-3x report-x"
            onClick={() => setReportUserOpen({ submit: false, confirm: false })}
          ></i>
          <div className="report-user-header">
            <div className="report-user-avi-container">
              <img
                src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${avatar}`}
                alt="avatar"
                className="report-avi"
              />
            </div>
            <h1 className="report-title">Report {channelid}</h1>
          </div>
          <div className="user-request-text white">
            Please select an item below to report this user:
          </div>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              if (
                (formData.text !== "" && isCurrent.racism) ||
                isCurrent.inappropriate ||
                isCurrent.spam ||
                isCurrent.impersonation ||
                isCurrent.threat ||
                isCurrent.other
              ) {
                reportUser(text, channelid, isCurrent);
                setReportUserOpen({ submit: false, confirm: true });
              }
            }}
          >
            <div className="report-choices">
              <input
                type="radio"
                checked={isCurrent.racism}
                value="racism"
                id="racism"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: e.target.checked,
                    inappropriate: false,
                    spam: false,
                    impersonation: false,
                    threat: false,
                    other: false,
                  })
                }
                name="racism"
              />
              <span className="option-background white mx-5">
                Racist or homophobic comment
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.inappropriate}
                value="inappropriate"
                id="inappropriate"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: e.target.checked,
                    spam: false,
                    impersonation: false,
                    threat: false,
                    other: false,
                  })
                }
                name="inappropriate"
              />
              <span className="option-background white mx-5">
                Indecent or inappropriate content
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.spam}
                value="spam"
                id="spam"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: e.target.checked,
                    impersonation: false,
                    threat: false,
                    other: false,
                  })
                }
                name="spam"
              />
              <span className="option-background white mx-5">Spam</span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.impersonation}
                value="impersonation"
                id="impersonation"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: false,
                    impersonation: e.target.checked,
                    threat: false,
                    other: false,
                  })
                }
                name="impersonation"
              />
              <span className="option-background white mx-5">
                False identity / fake account
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.threat}
                value="threat"
                id="threat"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: false,
                    impersonation: false,
                    threat: e.target.checked,
                    other: false,
                  })
                }
                name="threat"
              />
              <span className="option-background white mx-5">
                Threat made by this user
              </span>
              <br />
              <br />
              <input
                type="radio"
                checked={isCurrent.other}
                value="other"
                id="other"
                onChange={(e) =>
                  setCurrent({
                    ...isCurrent,
                    racism: false,
                    inappropriate: false,
                    spam: false,
                    impersonation: false,
                    threat: false,
                    other: e.target.checked,
                  })
                }
                name="other"
              />
              <span className="option-background white mx-5">Other</span>
              <br />
              <br />
            </div>
            <label htmlFor="email" className="report-user-input-label red">
              *Description:
            </label>
            <input
              className="report-user-input"
              type="text"
              name="text"
              placeholder="Enter Brief Description"
              onChange={(e) => onChange(e)}
            />
            <button
              className="report-button"
              onSubmit={(e) => {
                e.preventDefault();
                if (
                  (formData.text !== "" && isCurrent.racism) ||
                  isCurrent.inappropriate ||
                  isCurrent.spam ||
                  isCurrent.impersonation ||
                  isCurrent.threat ||
                  isCurrent.other
                ) {
                  reportUser(text, channelid, isCurrent);
                  setReportUserOpen({ submit: false, confirm: true });
                }
              }}
            >
              <i className="fas fa-exclamation-circle mx-5"></i>Report
            </button>
          </form>
        </div>
      </div>
    </Fragment>
  );
};

ReportUser.propTypes = {
  reportUser: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, {
  reportUser,
})(ReportUser);
